<template>
  <div>
    <el-dialog
      custom-class="real-dialog"
      :title="title"
      :visible.sync="dialogVisible"
      width="500px"
      @close="handleClose"
      center
      append-to-body
    >
      <el-row type="flex" justify="space-between" class="qr-box">
        <el-col :span="15">
          <div><span>车牌</span>{{plateNumber}}</div>
          <div><span>订单号</span>{{orderNo}}</div>
          <div><span>入场时间</span>{{cameAt}}</div>
        </el-col>
        <el-col :span="9">
          <span>二维码</span>
          <div>
            <vue-qr :text="qrcodUrl" :size="99" :margin="0"></vue-qr>
            <p @click="innerVisible = true">查看大图</p>
          </div>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClick">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="innerVisible">
      <vue-qr :text="qrcodUrl" :size="640" :margin="0"></vue-qr>
    </el-dialog>
  </div>
</template>

<script>
import showdialog from "@/minxs/showdialog";
import vueQr from 'vue-qr'
import { getCurrentTenant } from "@/api/module/park";

export default {
  components: {
    vueQr
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    parkingName: {
      type: String,
      default: '',
    },
    plateNumber: {
      type: String,
      default: '',
    },
    orderNo: {
      type: String,
      default: '',
    },
    cameAt: {
      type: String,
      default: '',
    },
    orderId: {
      type: Number,
      default: 0,
    },
    tId: {
      type: Number,
      default: 0,
    },
    parkLotId: {
      type: Number,
      default: 0,
    },
  },
  mixins: [showdialog],
  data() {
    return {
      qrcodUrl: '',
      innerVisible: false,
    };
  },
  mounted() {
    this.getDomain()
  },
  methods: {
    handleClick() {
      // console.log(this.form);
      this.$emit("update:showdialog", false);
    },
    getDomain() {
      getCurrentTenant({tenantId: this.tId, parkLotId: this.parkLotId}).then(res => {
        this.qrcodUrl = res.data.Domain + `name=${this.parkingName}&orderId=${this.orderId}&tId=${this.tId}&parkLotId=${this.parkLotId}`
      })
    },
  },
};
</script>

<style lang="scss">
  .qr-box{
    color: #333333;
    span{
      color: #909399;
      display: inline-block;
    }
    .el-col:first-of-type{
      line-height: 2.5;
      span{
        width: 24%;
      }
    }
    .el-col:last-of-type{
      display: flex;
      align-items: flex-start;
      span{
        margin-right: 5px;
      }
      p{
        text-align: center;
        background: #5E7FEC;
        color: #fff;
        line-height: 1.5;
        cursor: pointer;
      }
    }
  }
</style>
